import { Link } from "@tanstack/react-router";
import { SearchX } from "lucide-react";
import { common } from "../../copy/common";
import { errors } from "../../copy/errors";
import { buttonStyles } from "../ui/button-styles";
import { FullPage } from "./full-page";

/** 10d. We can't find that. */
export function NotFoundPage() {
  return (
    <FullPage icon={<SearchX className="size-6" />} title={errors.notFound.title}>
      <p className="text-sm text-muted-foreground">{errors.notFound.body}</p>
      <Link to="/" className={buttonStyles({ variant: "primary" })}>
        {common.goHome}
      </Link>
    </FullPage>
  );
}
